// extracted by mini-css-extract-plugin
module.exports = {"addressBoxWrapper":"styles_addressBoxWrapper__sFwSw","addressBoxList":"styles_addressBoxList__1idDB","addressBoxMapWrapper":"styles_addressBoxMapWrapper__3rgDh"};